<div class="btn" (click)="onViewDriverPolicy()">
    <i class="material-symbols-outlined" matPrefix>policy</i>
    <span class="link">View Driver's Policy</span>
</div>
